import { Box } from "@mui/material";
import { ReactComponent as Info } from "assets/Info.svg";
import { ReactComponent as TargetedPlan } from "assets/TargetedPlan.svg";
import { useTranslate } from "hooks/useTranslate";
import { tokens } from "styles/Tokens";
import ToolTip from "../Tooltip";
import Typography from "../Typography";
import "./index.scss";

interface TargetedPlanChipProps {
  variant: "vertical" | "horizontal";
  className?: string;
}

export default function TargetedPlanChip(props: TargetedPlanChipProps) {
  const translate = useTranslate();

  return (
    <Box className={`targeted-plan-chip targeted-plan-chip_${props.variant} ${props.className}`}>
      <Box className="label">
        <TargetedPlan />
        <Typography variant={"label"} color={tokens.Text.General.Color} showBold sx={{ marginTop: "1px" }}>
          {translate("common.targetedPlan")}
        </Typography>
      </Box>
      <Box component="div" className="tooltip">
        <ToolTip title={translate("common.targetedPlanTooltip")}>
          <Info />
        </ToolTip>
      </Box>
    </Box>
  );
}
